import React from "react";
import Slider from "react-slick";
import Brain from "../assets/Brain.png";
import Social from "../assets/Social.png";
import Arrow from "../Component/Arrow";
import "slick-carousel/slick/slick.css";
import Dumbbell from "../assets/Dumbbell.png";
import Rectangle from "../assets/Rectangle .png";

export const BadmintonBenefits = () => {
  let sliderRef = null;

  const handleLeft = () => sliderRef?.slickPrev();
  const handleRight = () => sliderRef?.slickNext();

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1440, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 425, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="bg-black text-white py-12 px-2  md:px-12">
      <div className="flex flex-col md:flex-row justify-between items-center mb-10 px-4">
        <div className="uppercase text-center md:text-left">
          <p className="font-league text-[48px] lg:text-[120px] leading-none">
            Why Badminton ?
          </p>
          <p className="text-[20px] md:text-[34px] text-[#6C6C6C] font-league">
            Why at Kosmos Badminton Academy?
          </p>
        </div>
        <div className="mt-6 md:mt-0">
          <Arrow onLeftClick={handleLeft} onRightClick={handleRight} />
        </div>
      </div>

      <Slider {...settings} ref={(slider) => (sliderRef = slider)}>
        <div className="md:px-4">
          <div className="min-h-[400px]  bg-[#1D1D1D] shadow-md flex flex-col justify-between p-12">
            <div className="flex justify-between items-center mb-4">
              <div className="bg-[#393939] py-2 px-3">
                <img
                  src={Dumbbell}
                  alt="Dumbbell Icon"
                  className="w-4 md:w-8 h-4 md:h-8"
                />
              </div>
              <div className="flex">
                <img
                  src={Rectangle}
                  alt="Icon 1"
                  className="w-4 md:w-8 h-4 md:h-8  object-contain -mr-[10px] md:-mr-[18px]"
                />
                <img
                  src={Rectangle}
                  alt="Icon 2"
                  className="w-4 md:w-8 h-4 md:h-8  object-contain -mr-[10px]  md:-mr-[18px]"
                />
                <img
                  src={Rectangle}
                  alt="Icon 3"
                  className="w-4 md:w-8 h-4 md:h-8  object-contain"
                />
              </div>
            </div>

            <p className="text-[26px] md:text-[32px] tracking-wide font-league uppercase">
              Holistic Health & Fitness
            </p>
            <ul className="list-disc list-outside  space-y-2 text-gray-300  font-articulat text-[12px] md:text-[14px] pt-4">
              <li>
                Fast‑paced rallies help strengthen your heart, improve blood
                circulation, and burn 300‑550 calories per hour
              </li>
              <li>
                Lunging, jumping, and smashing engages your legs, arms, and
                core—enhancing muscle tone, flexibility, balance, and
                coordination
              </li>
              <li>
                Weight‑bearing movements support stronger bones and better
                mobility over time.
              </li>
            </ul>
          </div>
        </div>

        <div className="md:px-4">
          <div
            className="min-h-[400px] shadow-md flex flex-col justify-between p-12"
            style={{
              background:
                "linear-gradient(to bottom right, #8A46DC, #433BCA, #191D80, #0B0D3E)",
            }}
          >
            <div className="flex justify-between items-center mb-4">
              <div className="py-2 px-3 bg-[#FFFFFF33]">
                <img
                  src={Brain}
                  alt="Brain Icon"
                  className="w-4 md:w-8 h-4 md:h-8"
                />
              </div>
            </div>
            <p className="text-[26px] md:text-[32px] tracking-wide font-league uppercase ">
              Sharpen Mind & Mood
            </p>
            <ul className="list-disc list-outside  space-y-2 text-white font-articulat text-[12px] md:text-[14px] pt-4">
              <li>
                Quick direction changes and strategic plays heighten
                concentration, reaction times, and mental sharpness
              </li>
              <li>
                Regular play releases endorphins, reduces anxiety and
                depression, and improves mood <br /> and sleep quality
              </li>
              <li>
                Visible skill progress, effective strategy, and friendly
                competition build confidence and mental toughness
              </li>
            </ul>
          </div>
        </div>

        <div className="md:px-4">
          <div className="min-h-[400px] bg-[#1D1D1D] shadow-md flex flex-col justify-between px-12 pt-12 pb-12 md:pb-20 lg:pb-10">
            <div className="flex justify-between items-center mb-3">
              <div className="bg-[#393939] py-2 px-3 ">
                <img
                  src={Social}
                  alt="Social Icon"
                  className="w-4 md:w-8 h-4 md:h-8 "
                />
              </div>
              <div className="flex">
                <img
                  src={Rectangle}
                  alt="Icon 1"
                  className="w-4 md:w-8 h-4 md:h-8   object-contain -mr-[10px]  md:-mr-[18px]"
                />
                <img
                  src={Rectangle}
                  alt="Icon 2"
                  className="w-4 md:w-8 h-4 md:h-8   object-contain -mr-[10px]  md:-mr-[18px]"
                />
                <img
                  src={Rectangle}
                  alt="Icon 3"
                  className="w-4 md:w-8 h-4 md:h-8  object-contain"
                />
              </div>
            </div>
            <p className="text-[28px] md:text-[32px] tracking-wide font-league uppercase ">
              Social Connection
            </p>
            <ul className="list-disc list-outside  space-y-2 text-gray-300 font-articulat text-[12px] md:text-[14px] pt-1">
              <li>
                Community ＆ Collaboration: Designed for doubles and team play,
                badminton fosters social bonds and lifelong friendships
              </li>
              <li>
                Play for Life: Suitable for all ages and fitness levels‑from
                beginners to serious players. Lightweight, inclusive, and easy
                to start anytime
              </li>
              <li>
                Live Longer ＆ Happier: Social racket sports like badminton are
                linked to a significantly longer lifespan.
              </li>
            </ul>
          </div>
        </div>
      </Slider>
    </div>
  );
};
